// Auth0 Configuration
// Make sure to set these environment variables in your .env file
export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
  },
  // Optional: Customize the login experience
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
};

// Validate that required environment variables are set
export const validateAuth0Config = () => {
  const requiredVars = ['REACT_APP_AUTH0_DOMAIN', 'REACT_APP_AUTH0_CLIENT_ID'];
  const missingVars = requiredVars.filter((varName) => !process.env[varName]);

  if (missingVars.length > 0) {
    // Missing required Auth0 environment variables
    return false;
  }

  return true;
};
